<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Use Gift Card'"
      [canGoBack]="false"
      [noBow]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <form [formGroup]="form">
    <tidy-wrapper>


      <tidy-card>
        <tidy-row [align]="'center'" class="extra-bottom-padding">
          <tidy-text
            [body]="'Enter your gift code, and we will apply it to your account. Credit from gifts are always used before charging your card'" />
        </tidy-row>

        <tidy-row class="field-top-padding">
          <tidy-input
            formControlName="code"
            [label]="'Gift Card Code'"
            [form]="form.controls.code"
            [submitted]="submitted"
            [errorMessage]="'Please enter a valid gift code.'"
            [icon]="'assets/svg/gift.svg'" />
        </tidy-row>
      </tidy-card>

      <tidy-error-message
        [text]="errorMessage" />

      <tidy-two-column-row>
        <tidy-button
          [text]="'Go Back'"
          [action]="boundGoBack"
          class="secondary" />
        <tidy-button
          [text]="'Apply Code'"
          class="primary"
          [action]="boundCheckGiftCode" />
      </tidy-two-column-row>

    </tidy-wrapper>
  </form>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
